"use client";

import { Wrench, Building2, Hammer, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  icon: Building2,
  label: "Industrial Welding"
}, {
  id: 2,
  icon: Wrench,
  label: "Commercial Welding"
}, {
  id: 3,
  icon: Hammer,
  label: "Structural Steel Work"
}, {
  id: 4,
  icon: Sparkles,
  label: "Custom Metal Fabrication"
}];
export default function OurWeldingServices() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section ref={sectionRef} className="bg-background py-16 px-6 md:px-12 lg:px-20">
      <div className="mx-auto max-w-6xl">
        <h2 className="mb-12 text-center font-display text-3xl font-bold text-foreground md:text-4xl">
          Our Welding Services
        </h2>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          const delay = i * 150;
          const hasFullBackground = i === 0 || i === 1 || i === 2 || i === 3;
          const getBackgroundImageClass = () => {
            if (i === 0) return "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1427264/img/image_5cq2y76e.jpg)]";
            if (i === 1) return "bg-[url(https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi17.jpg)]";
            if (i === 2) return "bg-[url(https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi7.jpg)]";
            if (i === 3) return "bg-[url(https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi14-1.jpg)]";
            return "";
          };
          if (i === 0) {
            return <Card key={service.id} data-index={i} style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(1rem)",
              transition: `opacity var(--duration-medium) var(--ease-smooth) ${delay}ms, transform var(--duration-medium) var(--ease-smooth) ${delay}ms`
            }} className={`border transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${hasFullBackground ? `${getBackgroundImageClass()} bg-cover bg-center border-primary/30 shadow-medium relative overflow-hidden` : "border-border bg-surface shadow-soft"}`}>
                  <CardHeader className={`items-center text-center ${hasFullBackground ? "relative z-10" : ""}`}>
                    <div className={`mb-4 flex h-16 w-16 items-center justify-center rounded-full transition-colors duration-[var(--duration-medium)] ${hasFullBackground ? "bg-white/20" : "bg-white/20"}`}>
                      <Icon className={`h-8 w-8 stroke-[1.5] transition-transform duration-[var(--duration-medium)] ${hasFullBackground ? "text-white" : "text-primary"}`} />
                    </div>
                  </CardHeader>
                  <CardContent className={`text-center ${hasFullBackground ? "relative z-10" : ""}`}>
                    <CardTitle className={`text-lg font-semibold ${hasFullBackground ? "text-foreground bg-primary-light px-4 py-2 rounded-md" : "text-foreground"}`}>
                      {service.label}
                    </CardTitle>
                  </CardContent>
                </Card>;
          }
          return <Card key={service.id} data-index={i} style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(1rem)",
            transition: `opacity var(--duration-medium) var(--ease-smooth) ${delay}ms, transform var(--duration-medium) var(--ease-smooth) ${delay}ms`
          }} className={`border transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${hasFullBackground ? `${getBackgroundImageClass()} bg-cover bg-center border-primary/30 shadow-medium relative overflow-hidden` : "border-border bg-surface shadow-soft"}`}>
                <CardHeader className={`items-center text-center ${hasFullBackground ? "relative z-10" : ""}`}>
                  <div className={`mb-4 flex h-16 w-16 items-center justify-center rounded-full transition-colors duration-[var(--duration-medium)] ${hasFullBackground ? "bg-white/20" : "bg-white/20"}`}>
                    <Icon className={`h-8 w-8 stroke-[1.5] transition-transform duration-[var(--duration-medium)] ${hasFullBackground ? "text-white" : "text-primary"}`} />
                  </div>
                </CardHeader>
                <CardContent className={`text-center ${hasFullBackground ? "relative z-10" : ""}`}>
                  <CardTitle className={`text-lg font-semibold ${hasFullBackground ? i === 1 ? "text-black bg-white px-4 py-2 rounded-md" : i === 2 ? "text-black bg-white px-4 py-2 rounded-md" : "text-black bg-white px-4 py-2 rounded-md" : "text-foreground"}`}>
                    {service.label}
                  </CardTitle>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}